import React, { useState } from "react";
import { TimeFormat } from "../date/TimeFormat.jsx";
import { VoucherBalanceStatus } from "./VoucherBalanceStatus.jsx";
import { VoucherModal } from "./VoucherModal.jsx";

/*

Mock data:

[
  {
    "id": 7,
    "is_active": true,
    "date_created": "2025-06-17T14:06:39.753882+01:00",
    "date_deactivated": null,
    "deactivated_by": null,
    "name": "Jan",
    "email": "jan@test.com",
    "phone": "test",
    "remark": null,
    "reserved_timeslot": "2025-06-18T17:00:00+01:00",
    "prepaid_product": {
      "id": 4,
      "name": "Kennismakingsvlucht",
      "description": "",
      "thank_you": "",
      "slug": "kennismakingsvlucht",
      "has_calendar": true,
      "duration": 60,
      "extras": [
        {
          "name": "test",
          "extra": "extra data",
          "field": "veld",
          "options": [
            "test",
            "asdf",
            "asdf2",
            "asdf5"
          ],
          "required": true,
          "input_type": "radio",
          "description": "extra"
        }
      ]
    },
    "payment_status": "paid",
    "notes": "",
    "extra": {
      "meer": [
        "test"
      ],
      "naam": "test",
      "veld": "test"
    },
    "ledger_balance": 90
  }
]

*/

export function VoucherCard({ vouchers }) {
  const [openVoucher, setOpenVoucher] = useState(null);

  // sort vouchers by reserved_timeslot
  vouchers = vouchers.sort((a, b) => {
    const tA = a.reserved_timeslot
      ? new Date(a.reserved_timeslot).getTime()
      : 0;
    const tB = b.reserved_timeslot
      ? new Date(b.reserved_timeslot).getTime()
      : 0;
    return tA - tB;
  });

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
        {vouchers.map((voucher) => {
          return (
            <div
              className="clickable"
              key={voucher.id}
              onClick={() => setOpenVoucher(voucher)}
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                width: "100%",
                gap: 6,
              }}
            >
              <VoucherBalanceStatus balance={voucher.ledger_balance} />
              
              <TimeFormat date={voucher.reserved_timeslot} />

              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: 0,
                  flex: 1,
                  wordBreak: "break-word",
                }}
              >
                <span style={{ fontWeight: 500 }}>
                  {voucher.prepaid_product?.name}
                </span>
                <span style={{ fontSize: 13, color: "#888", lineHeight: '11px' }}>
                  {voucher.name}
                </span>
              </span>
            </div>
          );
        })}
      </div>
      <VoucherModal
        open={!!openVoucher}
        voucher={openVoucher}
        onClose={() => setOpenVoucher(null)}
      />
    </>
  );
}
